const clientId = process.env.REACT_APP_CLIENT_ID;
const tenantId = process.env.REACT_APP_TENANT_ID;

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: [
    "User.Read",
    `api://${clientId}/access_as_user`,
  ],
};

export const apiConfig = {
  baseUrl: process.env.REACT_APP_API_BASE_URL || "http://localhost:7071",
};

export const getApiToken = async (msalInstance) => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) return null;
  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: [`api://${clientId}/access_as_user`],
      account: accounts[0],
    });
    return response.accessToken;
  } catch {
    msalInstance.acquireTokenRedirect({
      scopes: [`api://${clientId}/access_as_user`],
      account: accounts[0],
    });
    return null;
  }
};
